
export function controls(DOM) {
    const btnOpenSubMenu = document.querySelector("[data-action='toggle-submenu']")
    const main = document.querySelector("main")
    const mainHeader = document.querySelector(".main-header__content")
    const btnCloseMenuMobile = document.querySelector("[data-action='close-menu']")
    const btnAbrir = document.querySelector(".abrir")
    const headerSubMenu = document.querySelector(".header-submenu")
    const body = document.querySelector('body');
    const buttonCloseMenu = document.querySelector("[data-action=close-submenu]")

    function init(){
        eventListners.subMenuOpen()
        eventListners.subMenuClose()
        eventListners.closeSubMenu()
    }

    function openMenu() {
        main.classList.add("filter-cover")
        mainHeader.classList.add("active")
        body.classList.add('hidden-overflow')
        btnAbrir.classList.add("active")
        headerSubMenu.classList.add("open")

        if (body.classList.contains("mobile")) {
            DOM.header.classList.toggle("open-menu-mobile")
        } else {
            btnOpenSubMenu?.classList.toggle("close")
        }
    }

    const eventListners = {
        subMenuOpen(){
            btnOpenSubMenu.addEventListener('click', () => {
                openMenu();
            })
        },
        subMenuClose(){
            buttonCloseMenu.addEventListener("click", () => {
                closeHeaderSubMenu();
            });
        },
        closeSubMenu(){
            document.addEventListener("keydown", (event) => {
                if (event.key === "Escape") {
                    closeHeaderSubMenu()
                }
            });
        }
    }

    init();
}

export function closeHeaderSubMenu() {
    document.querySelector("body").style.overflowY = "auto";
    document.querySelector("main").classList.remove("filter-cover")
    document.querySelector(".main-header__content").classList.remove("active")
    document.querySelector('body').classList.remove('hidden-overflow')
    document.querySelector(".abrir").classList.remove("active")
    document.querySelector(".header-submenu").classList.remove("open")

    if (document.querySelector('body').classList.contains("mobile")) {
        document.querySelector(".open-menu-mobile")?.classList.remove("open-menu-mobile")
    }
}
